import { useMemo, useRef } from 'react';
import { useHoverDirty } from 'react-use';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';

import { Tooltip } from '../Tooltip';

type HoverableIconProps = {
  icon: React.ReactNode;
  tooltip: React.ReactNode;
  reverseMode?: boolean;
};

export const HoverableIcon = ({
  icon,
  tooltip,
  reverseMode,
}: HoverableIconProps) => {
  const { isDarkMode } = useSiteTheme();
  const ref = useRef<HTMLDivElement>(null);
  const isHovering = useHoverDirty(ref);

  const contentVariant = useMemo(() => {
    if (reverseMode) {
      return isDarkMode ? 'darkGray' : 'light';
    }
    return isDarkMode ? 'light' : 'darkGray';
  }, [isDarkMode, reverseMode]);

  return (
    <Tooltip
      align="center"
      open={isHovering}
      triggerContent={<div ref={ref}>{icon}</div>}
      contentVariant={contentVariant}
    >
      {tooltip}
    </Tooltip>
  );
};
